import { memo, forwardRef } from "react"

import { Icon } from "../icon"

import { IconButtonBase, IconMouseClickFocusRemover } from "./styles"
import { IconButtonProps } from "./types"

export const IconButton = memo<IconButtonProps>(
  forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ svgIcon, transform, ...props }, ref) => (
      <IconButtonBase {...props} ref={ref}>
        <Icon svgIcon={svgIcon} transform={transform} block />
        <IconMouseClickFocusRemover />
      </IconButtonBase>
    ),
  ),
)
